import { StarsButton } from '@ps/web-shared-components';
import React from 'react';

import styles from '../shared.scss';

import {
  TXTCLI_Bets_per_day,
  TXTCLI_Bets_per_month,
  TXTCLI_Daily_login_time,
  TXTCLI_Number_of_logins_per_month,
  TXTCLI_Time_between_login_sessions,
  TXTWCL_Net_loss_per_day,
  TXTWCL_Net_loss_per_month
} from './PlayingLimitsReminderContentCZ.messages.json';

const PlayingLimitsReminderContentCZ: React.FC = () => (
  <>
    <StarsButton
      variant="text"
      href="/account/responsible/restrict-volume"
      translation={TXTCLI_Bets_per_day}
      className={styles.link}
    />
    <StarsButton
      variant="text"
      href="/account/responsible/restrict-volume"
      translation={TXTCLI_Bets_per_month}
      className={styles.link}
    />
    <StarsButton
      variant="text"
      href="/account/responsible/restrict-volume"
      translation={TXTWCL_Net_loss_per_day}
      className={styles.link}
    />
    <StarsButton
      variant="text"
      href="/account/responsible/restrict-volume"
      translation={TXTWCL_Net_loss_per_month}
      className={styles.link}
    />
    <StarsButton
      variant="text"
      href="/account/responsible/restrict-login-time"
      translation={TXTCLI_Daily_login_time}
      className={styles.link}
    />
    <StarsButton
      variant="text"
      href="/account/responsible/restrict-number-of-logins"
      translation={TXTCLI_Number_of_logins_per_month}
      className={styles.link}
    />
    <StarsButton
      variant="text"
      href="/account/responsible/restrict-time-between-logins"
      translation={TXTCLI_Time_between_login_sessions}
      className={styles.link}
    />
  </>
);

export default PlayingLimitsReminderContentCZ;
